import { FC, memo } from 'react'

import { Page, PageFace } from 'ui/components/Page'

import { ManageLicensePageProps } from './ManageLicensePageProps'
import { ManageLicenseForm } from './components/ManageLicenseForm'
import { Footer } from './components/ManageLicenseForm/components/Footer'
import { useBehavior } from './components/ManageLicenseForm/hooks'

import * as SC from './styles'

export const ManageLicensePage: FC<ManageLicensePageProps> = memo((props) => {
  const { data, returnUrl } = props
  const { form } = data
  const { id, name } = form
  const {
    Field,
    config,
    isDirty,
    deleteLicense,
    saveLicense,
    Confirmation,
    isLeaveConfirmationNeeded,
    isPending,
    cancelEdit
  } = useBehavior({ form, returnUrl })

  return (
    <Page
      face={PageFace.SECONDARY}
      title="License Page"
      subTitle={id ? name : 'Create New License'}
      footer={
        <Footer
          onDelete={id ? deleteLicense : undefined}
          onSubmit={saveLicense}
          onCancel={cancelEdit}
          isSaving={isPending}
        />
      }
    >
      <Confirmation />
      <SC.PanelWithMargin rounded shadowed collapsible={false} title={`${id ? 'Edit' : 'Add New'} License Information`}>
        <ManageLicenseForm
          config={config}
          Field={Field}
          isDirty={isDirty}
          isLeaveConfirmationNeeded={isLeaveConfirmationNeeded}
          data={data}
        />
      </SC.PanelWithMargin>
    </Page>
  )
})
